var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.215,
    height: 15.88,
    viewBox: "0 0 12.215 15.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#758091;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.438,8.872h-.916V7.089a3.665,3.665,0,1,0-7.329-.05V8.872H8.277A1.531,1.531,0,0,0,6.75,10.4v7.329a1.531,1.531,0,0,0,1.527,1.527h9.161a1.531,1.531,0,0,0,1.527-1.527V10.4A1.531,1.531,0,0,0,17.438,8.872Zm-4.046,4.764v2.626a.547.547,0,0,1-.508.55.535.535,0,0,1-.561-.534V13.636a1.222,1.222,0,1,1,1.069,0Zm2.061-4.764H10.262V7.039a2.6,2.6,0,0,1,5.192,0Z",
    transform: "translate(-6.75 -3.374)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.47d8b12715d6dc42632566f83911db6d.svg";
export { ForwardRef as ReactComponent };